import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  stockistData: {
    data: {},
  },
  stockistRegistrationList: {
    list: {
      data: [],
      total: 0,
    },
  },
  stockistRegistrationData: {
    userID: '',
    registrationID: '',
    stockistOrderID: '',
    stockistDepositID: '',
  },
  stockistConsignmentDepositList: {
    list: {
      data: [],
      total: 0,
    },
  },
  stockistSearchData: {
    list: [],
  },
  stockistOrderReturnList: {
    list: {
      data: [],
      total: 0,
    },
  },
  stockistDepositRefundList: {
    list: {
      data: [],
      total: 0,
    },
  },
  stockistDailyTransactionList: {
    list: {
      data: [],
      total: 0,
    },
  },
  stockistDailyTransactionPayments: {
    list: [],
  },
  stockistSearchedProduct: {},
  stockistARSummaryList: {
    list: {
      data: [],
      total: 0,
    },
  },
  stockistConsignmentBalanceCalculationStatus: {
    data: {
      status: null,
      message: '',
    },
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
